import { Column, Row } from 'further-ui/components/Layout';
import { styled, Button, Typography } from '@mui/material';
import dataRoomEditImg from 'assets/images/data-room-edit.png';

const HeaderText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  maxWidth: 250,
}));

const PaddedColumn = styled(Column)(({ theme }) => {
  const pad = theme.spacing(theme.spacingSizes.lg);
  return {
    padding: pad,
    minHeight: `calc(152px + 2 * ${pad})`,
    backgroundColor: theme.palette.grey[900],
    borderRadius: Number(theme.shape.borderRadius) * 2,
    position: 'relative',
    overflow: 'hidden',
  };
});

const ImageGradient = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 250,
  top: 0,
  width: 390,
  height: '100%',
  background: `linear-gradient(to left, ${theme.palette.grey[900]}, transparent)`,
  zIndex: 1,
}));

const PreviewImage = styled('img')({
  position: 'absolute',
  left: 310,
  top: 24,
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'left top',
});

const ConfigureButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  background: theme.palette.common.white,
  color: theme.palette.grey[900],
  zIndex: 2,
}));

const EditCta: React.FC = () => (
  <PaddedColumn fullWidth justify="space-between">
    <ImageGradient />
    <PreviewImage src={dataRoomEditImg} alt="" />
    <Row>
      <HeaderText variant="h4">
        Edit your data room content and design here
      </HeaderText>
    </Row>
    <Row fullWidth justify="flex-end">
      <ConfigureButton size="large" variant="contained">
        Configure data room
      </ConfigureButton>
    </Row>
  </PaddedColumn>
);

export default EditCta;
